import React, { FC, useEffect } from 'react';
import {
  useEnvironment,
  useExperiments,
  useTranslation,
  WidgetProps,
} from '@wix/yoshi-flow-editor';
import { EmptyState } from './EmptyState/EmptyState';
import { Header } from './Header/Header';
import { Body } from './Body/Body';
import { PremiumDialog } from './Dialog/PremiumDialog/PremiumDialog';
import { HiddenServicesForSeo } from './HiddenServicesForSeo/HiddenServicesForSeo';
import { WidgetViewModelProvider } from './hooks/useWidgetViewModel';
import { WidgetActionsProvider } from './hooks/useWidgetActions';
import { WidgetViewModel } from '../../../viewModel/viewModel';
import { WidgetActions } from '../../../actions/actions';
import { classes, st } from './Widget.st.css';
import { Dialog } from './Dialog/Dialog';

export type ControllerProps = {
  widgetViewModel: WidgetViewModel;
  widgetActions: WidgetActions;
};

export const Widget: FC<WidgetProps<ControllerProps>> = (props) => {
  return props.widgetActions && props.widgetViewModel ? (
    <WidgetRenderer {...props} />
  ) : null;
};

const WidgetRenderer: FC<WidgetProps<ControllerProps>> = (props) => {
  const { widgetViewModel, widgetActions } = props;
  const { headerViewModel, services, seo } = widgetViewModel;
  const { isRTL, isMobile } = useEnvironment();
  const { t } = useTranslation();
  const { experiments } = useExperiments();

  useEffect(() => {
    props.widgetActions.getCourseAvailability();
  }, []);

  return (
    <div
      data-hook="widget"
      className={st(classes.root, {
        isRTL,
        isMobile,
        isNavigating: !!widgetViewModel.navigatingToService,
      })}
    >
      <WidgetViewModelProvider value={widgetViewModel}>
        <WidgetActionsProvider value={widgetActions}>
          {services.length ? (
            <>
              <Dialog
                widgetViewModel={widgetViewModel}
                widgetActions={widgetActions}
              />

              {headerViewModel ? <Header /> : null}
              <Body widgetId={props.id} />
              {seo && seo.shouldListServicesFromOtherCategories ? (
                <HiddenServicesForSeo />
              ) : null}
            </>
          ) : (
            <EmptyState />
          )}
        </WidgetActionsProvider>
      </WidgetViewModelProvider>
    </div>
  );
};
